/**
 * Korean (KRW base) cross-currency transactions for the multi-currency use
 * case. Foreign-currency rows carry their own symbol so the real DataTable
 * renders a ₩/$/€/¥ mix; the transfer pair shows both sides via `paired*`.
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_CROSS_CURRENCY_TRANSACTIONS_KO = [
	{
		id: 'xcur-1',
		isTransferPair: true,
		date: '2026-08-05',
		type: 'Transfer',
		amount: 690000,
		description: '미국 증권으로',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '저축',
		pairedType: 'Transfer',
		pairedAmount: 500,
		pairedCurrencySymbol: '$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '미국 증권',
		pairedAccountId: 'acc-us',
		pairedDate: '2026-08-05',
	},
	{
		id: 'xcur-2',
		date: '2026-08-04',
		type: 'Deposit',
		amount: 3500000,
		description: '월급',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '수입',
	},
	{
		id: 'xcur-3',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 129,
		description: '소프트웨어 구독',
		accountId: 'acc-us',
		accountName: '미국 증권',
		currency: 'USD',
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		tagNames: '업무',
	},
	{
		id: 'xcur-4',
		date: '2026-07-29',
		type: 'Purchase',
		amount: 42.5,
		description: '파리 호텔',
		accountId: 'acc-eur',
		accountName: '유로 카드',
		currency: 'EUR',
		currencySymbol: '\u20AC',
		currencyDecimalPlaces: 2,
		tagNames: '여행',
	},
	{
		id: 'xcur-5',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 1280,
		description: '편의점',
		accountId: 'acc-jpy',
		accountName: '일본 카드',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '식비',
	},
];
